<div class="container vh-100 vw-100 d-flex column-gap-20 ptb-20 plr-50">
  <ng-container *ngFor="let lot of lotsList; let index = index">
    <div class="group fade-in">
      <div
        class="group__header d-flex direction-column align-space-between mb-5"
      >
        <div
          class="header__title d-flex direction-row align-center justify-space-between"
        >
          <span class="d-flex align-center">
            <h1 class="pr-20">NOVO LOTE</h1>
            <small>
              {{ lot?.Contracts?.length }} /
              {{ getAmountContract }}
            </small>
          </span>

          <button
            *ngIf="lotsList.length > 1"
            class="btn-icon"
            (click)="deleteLot(lot)"
          >
            <app-svg-icon
              src="assets/icons/trash-solid-icon.svg"
              width="17px"
              height="18px"
              color="white"
            ></app-svg-icon>
          </button>
        </div>
        <div
          class="header__action d-flex align-center justify-center"
          role="button"
          tabindex="0"
          (click)="openAddContractModal(lot)"
          (keydown.enter)="openAddContractModal(lot)"
          (keydown.space)="openAddContractModal(lot)"
        >
          <app-svg-icon
            src="assets/icons/plus-regular-icon.svg"
            width="15px"
            height="15px"
            color="white"
          ></app-svg-icon>

          <span class="pl-8">Adicionar contratos</span>
        </div>
      </div>
      <div class="group__body">
        <app-contract-card-dialog
          [contractList]="lot.Contracts || []"
          [originalContractIds]="originalContractIds"
        ></app-contract-card-dialog>
      </div>
    </div>
  </ng-container>

  <div *ngIf="false" class="button d-flex align-center justify-center">
    <button class="btn-icon pl-25 pr-50" (click)="addLotGroup()">
      <app-svg-icon
        src="assets/icons/plus-regular-icon.svg"
        width="56px"
        height="56px"
        color="successBlue"
      ></app-svg-icon>
    </button>
  </div>
</div>
